import React from 'react';
import classNames from 'classnames';
// import propTypes from 'prop-types';

import { Icon, Progressbar, Tooltip } from '@common/ui/general';

// import Up from '@profile_common/images/svg/Up.svg';
// import Down from '@profile_common/images/svg/Down.svg';

function ProgressedPerformance({
  title, subtitle, icon, progress, className, tooltip, progressBarClassName,
  valueClassName,
}) {
  // const trendIcon = trend === 'up' ? Up : Down;

  return (
    <div className={classNames(
      'progressed-performance',
      { [className]: className },
    )}
    >
      <div className="progressed-performance__title-row">
        {icon
          && (
            <img
              src={icon}
              alt={title}
              className="progressed-performance__icon show-in-tablet"
            />
          )}
        <Tooltip
          className="progressed-performance__title row align-c"
          component="h3"
          isDisabled={!tooltip}
          title={tooltip || ''}
        >
          {title}
          {!!tooltip && <Icon className="m-l-5" name="info" />}
        </Tooltip>
        <span className="progressed-performance__subtitle">
          {subtitle}
        </span>
      </div>
      <div className="progressed-performance__body-row">
        {icon
          && (
            <img
              src={icon}
              alt={title}
              className="progressed-performance__icon hide-in-tablet"
            />
          )}
        <div className="progressed-performance__bar">
          <Progressbar
            limit={100}
            value={progress}
            className={classNames('progressed-performance__progress-bar',
              { [progressBarClassName]: progressBarClassName })}
            renderValue={false}
          />
        </div>
        <span className={classNames('progressed-performance__value',
          { [valueClassName]: valueClassName })}
        >
          {`${progress}%`}
        </span>
        {/* <img
          src={trendIcon}
          alt={trend}
          className="progressed-performance__trend"
        /> */}
      </div>
    </div>
  );
}

export default ProgressedPerformance;
